<template>
    <main>
        <About />
        <plant />
        <Ad />
        <milestone />
        <Market />
        <Certification />
        <Video />
    </main>
</template>

<script>
import About from './_about'
import Ad from './_ad'
import Profile from './_profile'
import plant from './_plant'
import milestone from './_milestone'
import Market from './_market'
import Certification  from './_certification'
import Video  from './_video'

export default {
    components: {
        About,
        Ad,
        Profile,
        plant,
        milestone,
        Market,
        Certification,
        Video
    }
}
</script>

<style>

</style>